import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../config/config';
import { FiArrowRight, FiBookOpen, FiClock, FiDollarSign } from 'react-icons/fi';
import { NavLink } from 'react-router-dom';

const ProgramSection = () => {
    const [programs, setPrograms] = useState([]);

    useEffect(() => {
        const fetchPrograms = async () => {
            try {
                // Assuming this endpoint exists based on Admin naming conventions
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/get_program`);
                setPrograms(response.data.programs || []);
            } catch (error) {
                console.error("Error fetching programs:", error);

                // Fallback dummy data if API fails (to prevent breaking UI if endpoint doesn't exist)
                setPrograms([
                    // Dummy data structure imitating generic program/course
                    { _id: '1', programName: 'Computer Science', duration: '4 Years', fees: '2.5L' },
                    { _id: '2', programName: 'Mechanical Eng.', duration: '4 Years', fees: '2.4L' },
                    { _id: '3', programName: 'Civil Engineering', duration: '4 Years', fees: '2.2L' },
                    { _id: '4', programName: 'Electrical Eng.', duration: '4 Years', fees: '2.5L' },
                ]);
            }
        };
        fetchPrograms();
    }, []);

    return (
        <section className="py-24 bg-gray-50">
            <div className="container mx-auto px-4">
                {/* Outer Border Container */}
                <div className="border-2 border-orange-200 rounded-3xl p-8 bg-white shadow-sm hover:shadow-md transition-shadow duration-300">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl font-bold text-gray-800 mb-2">Featured <span className="text-brand-orange">Programs</span></h2>
                        <p className="text-gray-500 max-w-2xl mx-auto">Discover the most sought-after courses that can shape your future career.</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {programs.map((program, index) => (
                            <div key={index} className="bg-gray-50 rounded-3xl p-6 shadow-lg border border-gray-100 hover:shadow-2xl hover:-translate-y-1 transition duration-300 group">
                                <div className="bg-orange-50 w-12 h-12 rounded-xl flex items-center justify-center text-brand-orange text-xl mb-4 group-hover:scale-110 transition">
                                    <FiBookOpen />
                                </div>

                                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-brand-orange transition">
                                    {program.programName || "Program Name"}
                                </h3>

                                <div className="flex items-center text-sm text-gray-500 mb-4 space-x-4">
                                    <div className="flex items-center">
                                        <FiClock className="mr-1 text-gray-400" />
                                        {program.duration || "N/A"}
                                    </div>
                                    <div className="flex items-center">
                                        <FiDollarSign className="mr-1 text-gray-400" />
                                        {program.fees ? `₹${program.fees}` : "Fees N/A"}
                                    </div>
                                </div>

                                <NavLink
                                    to={`/program/${program._id}`}
                                    className="inline-flex items-center text-sm font-bold text-gray-400 group-hover:text-brand-orange transition"
                                >
                                    View Details <FiArrowRight className="ml-2 transform group-hover:translate-x-1 transition" />
                                </NavLink>
                            </div>
                        ))}

                        {programs.length === 0 && (
                            <div className="col-span-full text-center text-gray-400 py-10">No programs available at the moment.</div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProgramSection;
